/**
 * Whether a useReq request has settled — produced a result or an error.
 *
 * Why this exists: @larner.dev/use-req initializes state as
 * `{ loading: false, result: null, error: null }` and callers fire the fetch
 * in a post-paint useEffect. So on the very first frame `loading` is still
 * false, and gating a loader on `loading` alone flashes the empty/error
 * branch before the request has even started. Gate first-load UI on
 * "not yet settled" instead: `!reqSettled(state)`.
 *
 * Note the hook also resets `result`/`error` synchronously when a NEW request
 * starts, so this returns false again during refetches. Call sites that want
 * to keep stale content visible across a refetch should cache the last result
 * themselves (see Matches.tsx for the pattern).
 */
export const reqSettled = (state: {
  result?: unknown;
  error?: unknown;
}): boolean => Boolean(state.result || state.error);
